import React from 'react';
import { FormFieldHeader } from '../../../../components/FormFieldHeader';
import classNames from 'classnames';

interface PropTypes {
  name: string;
  error?: string;
  placeholder?: string;
  onName?: (value: string) => void;
  readOnly?: boolean;
  maximumCharacters?: number;
}

export function NameInput(props: PropTypes) {
  return (
    <div>
      <FormFieldHeader
        fieldName='Name'
        isRequired={!props.readOnly}
        classNames='fw-semibold'
        maximumCharacters={props.maximumCharacters}
      />
      <input
        className={classNames('form-control fs-5', props.error && 'is-invalid')}
        placeholder={props.placeholder}
        value={props.name}
        onChange={(event) => props.onName(event.target.value)}
        disabled={props.readOnly}
      />
      {props.error && (
        <div className='invalid-feedback d-block fs-6'>{props.error}</div>
      )}
    </div>
  );
}
